import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import { config } from '../config/config';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <Navbar />
      <section className="process" style={{ minHeight: '80vh', paddingTop: '100px' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{ maxWidth: '800px', margin: '0 auto', padding: '0 20px' }}
        >
          <p className="sec-label">Legal</p>
          <h2 className="sec-title" style={{ color: 'var(--black)' }}>
            PRIVACY <span style={{ color: 'var(--gold)' }}>POLICY</span>
          </h2>
          
          <div style={{
            background: 'var(--white)',
            border: '3px solid var(--black)',
            borderRadius: '8px',
            padding: '40px',
            marginTop: '40px',
            lineHeight: '1.8'
          }}>
            <div style={{ marginBottom: '30px' }}>
              <p style={{ fontSize: '16px', color: 'var(--black)', lineHeight: '1.8' }}>
                At <strong>JS Kuber</strong>, reachable from{' '}
                <a 
                  href="https://jskuber.in/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: 'var(--gold)', textDecoration: 'none', fontWeight: 'bold' }}
                >
                  https://jskuber.in/
                </a>, your privacy is our priority. We only collect information like Name and Contact details to provide gold valuation services. We strictly follow the legal guidelines for gold buying and ensure that your identity and transaction details are kept confidential. We do not share your data with unauthorized third parties. By using our website, you hereby consent to our Privacy Policy.
              </p>
            </div>
            
            <div style={{
              marginTop: '40px',
              padding: '30px',
              background: 'var(--cream)',
              border: '2px solid var(--gold)',
              borderRadius: '4px'
            }}>
              <h3 style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: '24px',
                letterSpacing: '2px',
                marginBottom: '20px',
                color: 'var(--black)'
              }}>
                Contact Us
              </h3>
              <p style={{ marginBottom: '16px', color: 'var(--black)' }}>
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                color: 'var(--black)'
              }}>
                <li style={{ marginBottom: '12px', fontSize: '15px' }}>
                  <strong>📞 Phone:</strong>{' '}
                  <a 
                    href={`tel:${config.business.contact}`}
                    style={{ color: 'var(--gold)', textDecoration: 'none', fontWeight: 'bold' }}
                  >
                    +91-{config.business.contact}
                  </a>
                </li>
                <li style={{ marginBottom: '12px', fontSize: '15px' }}>
                  <strong>✉️ Email:</strong>{' '}
                  <a 
                    href={`mailto:${config.business.email}`}
                    style={{ color: 'var(--gold)', textDecoration: 'none' }}
                  >
                    {config.business.email}
                  </a>
                </li>
                <li style={{ marginBottom: '12px', fontSize: '15px' }}>
                  <strong>📍 Address:</strong> {config.business.address}
                </li>
              </ul>
            </div>

            <div style={{
              marginTop: '30px',
              paddingTop: '20px',
              borderTop: '2px solid var(--light)',
              textAlign: 'center'
            }}>
              <p style={{ 
                fontSize: '13px', 
                color: 'var(--gray)',
                fontStyle: 'italic'
              }}>
                Last updated: {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>

            <div style={{ marginTop: '40px', textAlign: 'center' }}>
              <Link to="/" className="btn-big filled">
                ← Back to Home
              </Link>
            </div>
          </div>
        </motion.div>
      </section>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
